/**
 * Client helpers for `auth_internal_domains` — SSI Entra email domains.
 *
 * The allowlist is loaded from public `GET /api/auth/internal-domains` so the
 * login page can route SSI Sign-in to Microsoft without hardcoding domains.
 */

/** Extract the lowercase email domain (portion after `@`), or `''` when absent. */
export function emailDomainOf(email: string | null | undefined): string {
  const normalized = (email ?? '').trim().toLowerCase();
  if (!normalized.includes('@')) return '';
  return normalized.split('@')[1] ?? '';
}

/**
 * Whether the email belongs to a configured active internal SSI domain.
 *
 * @param email - Candidate address.
 * @param domains - Lowercase domain names from the public probe (no `@`).
 */
export function isInternalEmail(
  email: string | null | undefined,
  domains: readonly string[] | null | undefined,
): boolean {
  if (!domains || domains.length === 0) return false;
  const domain = emailDomainOf(email);
  if (!domain) return false;
  return domains.includes(domain);
}
